import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "crm:relative crm:border-t-0 crm:border-r-0 crm:border-l-0 crm:border-b crm:border-solid crm:py-4 crm:px-4 crm:hidden crm:lg:block" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "crm:font-bold crm:text-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "crm:my-6 crm:relative"
}
const _hoisted_7 = {
  key: 1,
  class: "crm:mt-4!"
}
const _hoisted_8 = { class: "crm:my-2 crm:relative" }
const _hoisted_9 = { class: "crm:my-6 crm:relative" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 0 }

import {ref, inject} from "vue";
import AppPopoverAssistenza from "./AppPopoverAssistenza.vue";
import AppSidebarNavigationItem from "../layouts/AppSidebarNavigationItem.vue";
import {delete_cross, arrows_left, arrows_right, omnia_logo} from "../svg/svgs.js"


export default {
  __name: 'TheMainSidebar',
  props: {
  /**
   * Mainame dell'utente connesso
   */
  mainname: {
    type: String,
    default: null
  },
  /**
   * Nome utente dell'utente connesso
   * nel caso di login via OTP si tratta del'email di accesso
   */
  nomeUtente: {
    type: String,
    default: ''
  },
  navigation: {
    type: Object,
    default() {
      return {}
    },
    required: true
  },
  dati: {
    type: [Object, Array],
    default() {
      return {}
    }
  }
},
  emits: [
  'sidebar:toggle'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Renderizza e gestisce la visualizzazione della sidebar laterale.
 * Può essere ridotta/espansa.
 * Se ridotta, quando ci si passa sopra il mouse ritorna in sovraimpressione
 */
const props = __props

const emits = __emit

/**
 * @inject {$BaseVueUtils} metodi js prelevati dal framework
 */
const $BaseVueUtils = inject('$BaseVueUtils');

const is_sidebar_closed = ref(false);
const is_sidebar_open = ref(true);
const is_sidebar_hover = ref(false);

/**
 * @inject {isMobile} - recupera il valore se siamo nella modalità mobile oppure no
 */
const isMobile = inject('isMobile')


/**
 * @inject {toggleSidebarOpen} - recupera il metodo per il toggle della sidebar
 */
const toggleSidebarOpen = inject('toggleSidebarOpen')

/**
 * Gestisce il riduci/espandi della sidebar.
 * Emitta il risultato al padre in caso dei componenti debbano modificare di aspetto in caso
 * di sidebar ridotta/espansa
 */
function isToggleSidebar() {
  is_sidebar_closed.value = !is_sidebar_closed.value
  is_sidebar_open.value = is_sidebar_closed.value ? !is_sidebar_open.value : true;
  emits('sidebar:toggle', is_sidebar_open.value)
}

/**
 * Gestisce il riduci/espandi nella casistica che si passi sopra con il mouse
 * @param is_leave
 */
function isToggleHoverSidebar(is_leave = false) {
  is_sidebar_open.value = is_sidebar_closed.value ? !is_leave : is_sidebar_open.value;
  is_sidebar_hover.value = !is_leave;
}

const $DesignSystem = inject('$DesignSystem')

/**
 * Gestisce l'espandi nella casistica che la voce di menu della sidebar possegga delle sottovoci
 * ex. Preventivi che possiede le voci di Calcolatore, Storico ...
 * @param item
 */
function changeExpand(item) {
  item.isExpand = item['isExpand'] !== undefined ? !item.isExpand : true;
}

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["crm:bg-white crm:shadow-lg crm:fixed crm:top-0 crm:left-0 crm:h-full crm:transition-all crm:ease-out crm:border-r crm:border-solid crm:w-full", [is_sidebar_open.value ? 'crm:lg:w-52' : 'crm:lg:w-20', is_sidebar_hover.value ? 'crm:border-primary': '', is_sidebar_open.value && _unref(isMobile) ? 'crm:overflow-y-auto' : '']]),
    onMouseover: _cache[1] || (_cache[1] = $event => (isToggleHoverSidebar())),
    onMouseleave: _cache[2] || (_cache[2] = $event => (isToggleHoverSidebar(true)))
  }, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_base_icon, {
          key: 0,
          icon: _unref(delete_cross),
          class: "crm:absolute crm:right-4 crm:top-4 crm:cursor-pointer",
          sizing: {width: '15px', height: '15px'},
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_unref(toggleSidebarOpen)(false)), ["prevent"]))
        }, null, 8 /* PROPS */, ["icon"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" informazioni studio "),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({
      'crm:h-[150px] crm:mt-1':__props.dati.parametri.logo_studio && is_sidebar_open.value,
      'crm:h-[50px] crm:mt-4':__props.dati.parametri.logo_studio && !is_sidebar_open.value,
      'crm:h-[30px]':!__props.dati.parametri.logo_studio,
      })
      }, [
        (__props.dati.parametri.logo_studio)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "crm:my-2 crm:overflow-hidden crm:flex crm:items-center crm:justify-center crm:m-auto",
              style: _normalizeStyle(is_sidebar_open.value ? 'width: 150px; height: 150px;' : 'width: 50px; height: 50px;')
            }, [
              _createCommentVNode(" logo studio notarile "),
              _createElementVNode("img", {
                src: __props.dati.parametri.logo_studio,
                alt: "logo studio notarile"
              }, null, 8 /* PROPS */, _hoisted_2)
            ], 4 /* STYLE */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("p", _hoisted_3, _toDisplayString(is_sidebar_open.value && !__props.dati.parametri.logo_studio ? __props.dati.parametri.nome_studio : ''), 1 /* TEXT */),
      _createElementVNode("span", {
        onClick: _withModifiers(isToggleSidebar, ["prevent"]),
        class: "crm:cursor-pointer crm:hidden crm:lg:flex crm:items-center crm:justify-center crm:inline-block crm:p-4 crm:bg-primary crm:text-white crm:text-center crm:rounded-full crm:absolute crm:w-5 crm:h-5 crm:-right-4 crm:-bottom-4"
      }, [
        (!is_sidebar_closed.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_base_icon, {
                icon: _unref(arrows_left),
                stroke: "#fff",
                "stroke-width": "2",
                sizing: {width:'10px', height: '10px'}
              }, null, 8 /* PROPS */, ["icon"])
            ]))
          : _createCommentVNode("v-if", true),
        (is_sidebar_closed.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_base_icon, {
                icon: _unref(arrows_right),
                stroke: "#fff",
                "stroke-width": "2",
                sizing: {width:'10px', height: '10px'}
              }, null, 8 /* PROPS */, ["icon"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createCommentVNode(" sidebar menu "),
    _createElementVNode("section", {
      class: _normalizeClass(["crm:border-t-0 crm:border-r-0 crm:border-l-0 crm:border-b crm:border-solid crm:py-4 crm:px-4", [!is_sidebar_open.value ? 'crm:justify-center crm:flex' : '']])
    }, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigation, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.visible)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createVNode(AppSidebarNavigationItem, {
                    item: item,
                    is_sidebar_open: is_sidebar_open.value,
                    "onToggle:expand": changeExpand
                  }, null, 8 /* PROPS */, ["item", "is_sidebar_open"]),
                  (item.is_popover && _unref(isMobile))
                    ? (_openBlock(), _createBlock(AppPopoverAssistenza, {
                        key: 0,
                        mainname: __props.mainname,
                        "nome-utente": __props.nomeUtente
                      }, null, 8 /* PROPS */, ["mainname", "nome-utente"]))
                    : _createCommentVNode("v-if", true),
                  (item.children && item.isExpand)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                          return (_openBlock(), _createElementBlock("li", _hoisted_8, [
                            _createVNode(AppSidebarNavigationItem, {
                              item: child,
                              is_sidebar_open: is_sidebar_open.value
                            }, null, 8 /* PROPS */, ["item", "is_sidebar_open"])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ], 2 /* CLASS */),
    _renderSlot(_ctx.$slots, "default", { is_sidebar_open_slot: is_sidebar_open.value }),
    (__props.dati.is_notaio)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass(["crm:py-0 crm:px-4", [!is_sidebar_open.value ? 'crm:justify-center crm:flex' : '']])
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                href: !__props.dati.features.omnia ? 'https://omnia.polonotarilezucchetti.it/' : _unref($BaseVueUtils).ssoChangeDomainTo(__props.dati.ambiente, 'omnia','/omnia/home'),
                class: "crm:flex crm:items-center",
                target: "_blank"
              }, [
                _createVNode(_component_base_icon, {
                  icon: _unref(omnia_logo),
                  class: _normalizeClass({'crm:mr-4':is_sidebar_open.value})
                }, null, 8 /* PROPS */, ["icon", "class"]),
                (is_sidebar_open.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Omnia"))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_10)
            ])
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode("    <base-footer v-if=\"isMobile\"></base-footer>")
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

}